import _ from 'lodash';
import async from 'async';
import SoundManager from '../utils/SoundManager';
import Utils from '../utils/Utils';

class Cell extends Phaser.Group {

    static get CELL_WEIGHT()
    {
        return 150;
    }

    static get CELL_HEIGHT()
    {
        return 140;
    }

    constructor(game, cellModel)
    {
        super(game);

        this._model = cellModel;

        let dummy = this._dummy = new Phaser.Graphics(game, 0, 0);
        dummy.beginFill(0xFF0000, 0);
        dummy.drawRect(0, 0, Cell.CELL_WEIGHT, Cell.CELL_HEIGHT * cellModel.cells);
        dummy.endFill();
        this.addChild(dummy);

        let animationContainer = this._animationContainer = new Phaser.Group(game);
        animationContainer.x = 1;
        this.addChild(animationContainer);

        let sprite = this._view = new Phaser.Sprite(game, 0, 0, `slot-symbol-${cellModel.symbol}`, 0);
        animationContainer.addChild(sprite);
    }

    get model()
    {
        return this._model;
    }

//    setCell( cellModel )
//    {
//        this._model = cellModel;
//        
//        let sprite = new Phaser.Sprite( this.game, 0,0, `slot-symbol-${cellModel.symbol}`, 0);
//        this._animationContainer.addChild( sprite );
//        this._animationContainer.removeChild( this._view );
//        this._view = sprite;
//    }
    
    /**
     * Transfotm to extra sybmol
     * @param type - wild | scatter
     * @returns {Promise}
     */
    transform()
    {
        let sprite = this._view;
        let model = this.model;

        return new Promise((res) =>
        {
            let animation = sprite.animations.add('animation', model.transformFrames, 20, true, true);
            this._animations = this._animations || [];
            this._animations.push(animation);

            animation.play(20, false).onComplete.addOnce(() =>
            {
                let highlights = [].concat(model.highlight);
                let promiseResolveTimeout = 0;

                if (SoundManager.sound)
                {
                    SoundManager.fadeOutMusic(100);
                    SoundManager.playSound('sounds/wild-scatter');
                    promiseResolveTimeout = 2000;
                    setTimeout(() => SoundManager.fadeInMusic(1000), 1000);
                }

                if (highlights.length === 1)
                {
                    let animation = sprite.animations
                        .add('animation', highlights[0] === 'scatter' ? model.scatterFrames : model.wildFrames, 20, true, true);
                    animation.onStart.addOnce(() =>
                    {
                        if (!model.highlight)
                        {
                            return;
                        }

                    });
                    animation.play(20, true);

                    return res(Promise.resolve());
                }
                else
                {
                    let animations = highlights.map((highlight) =>
                    {
                        return sprite.animations
                            .add('animation', highlight === 'scatter' ? model.scatterFrames : model.wildFrames, 20, true, true);
                    });

                    this._animations = animations;

                    let animationCycles = 2;
                    async.whilst(
                        () => animations.length && !animations[0].isPaused,
                        (cbk) =>
                        {
                            if (animationCycles)
                            {
                                animationCycles--;
                            }
                            else
                            {
                                //res(Utils.makeTimeoutPromise(promiseResolveTimeout));
                                //return res(Promise.resolve());
                            }

                            let animation = animations.shift();
                            animations.push(animation);

                            animation.onLoop.addOnce(() => cbk());
                            animation.play(20, true);
                        },
                        () => console.log(`stop ${highlights.join('-')} animations`)
                    );

                    return res(Promise.resolve());
                }
            });
        });
    }

    hightlight()
    {
        let sprite = this._view;
        let model = this.model;

        if (!model.highlight)
        {
            return Promise.resolve();
        }

        switch (model.type)
        {
            case 'regular':
                return new Promise((res) =>
                {
                    let animation = sprite.animations.add('animation', model.highlightFrames, 20, true, true);
                    this._animations = this._animations || [];
                    this._animations.push(animation);
                    animation.play(20, true).onLoop.addOnce(() => res(Promise.resolve()));
                });
                break;

            case 'extra':

                break;

            default:
                return Promise.reject('Unsupported cell type.')
        }
    }

    stop(resetType = '')
    {
        let animations = this._animations;

        if (!animations)
        {
            return;
        }

        animations.forEach((animation) =>
        {
            switch (resetType)
            {
                case 'frame':
                    animation.stop(true);
                    break;

                case 'loop':
                    animation.loop = false;
                    break;

                default:
                    animation.stop();
            }
        });
        animations.length = 0;
    }
}

export default class Slot extends Phaser.Group {

    constructor(game, { cellModels } = {})
    {
        super(game);

        if (!cellModels || cellModels.length < 3)
        {
            throw new Error('[Slot.constructor] Invalid cell models.');
        }

        this._initialCellModels = cellModels;
        this.slotIndex = cellModels[0].slotIndex; 

        let bg = this._bg = new Phaser.Image(game, 0, 0, 'slot.bg');
        this.addChild(bg);

        let cellsContainer = this._cellsContainer = new Phaser.Group(game);
        this.addChild(cellsContainer);

        this.setCells( cellModels );

        cellsContainer.position.set(
            bg.width - cellsContainer.width >> 1,
            10
        );

        let cellsMask = new Phaser.Graphics(game, 0, 0);
        cellsMask.beginFill(0xFFFFFF, 0);
        cellsMask.drawRect(cellsContainer.x, cellsContainer.y - 4, cellsContainer.width, Cell.CELL_HEIGHT * 3 + 8);
        cellsMask.endFill();
        this.addChild(cellsMask);
        setTimeout(() =>
        {
            cellsContainer.mask = cellsMask;
        }, 1000);

        let animationContainer = this._animationContainer = new Phaser.Group(game);
        let mixIndexes = [1, 2, 3, 4, 5].sort(() => Math.random() - 0.5);
        let mix1 = this._mix1 = new Phaser.Image(game, 0, 0, `slot.symbols-mix-${mixIndexes.pop()}`);
        let mix2 = this._mix2 = new Phaser.Image(game, 0, mix1.height, `slot.symbols-mix-${mixIndexes.pop()}`);
        this._mixBounds = mix1.getLocalBounds();

        animationContainer.addChild(mix1);
        animationContainer.addChild(mix2);
        animationContainer.position.set(cellsContainer.x, cellsContainer.y);
        animationContainer.visible = false;
        this.addChild(animationContainer);

        let slotsMask = new Phaser.Graphics(game, 0, 0);
        slotsMask.beginFill(0xFFFFFF, 0);
        slotsMask.drawRect(cellsContainer.x, cellsContainer.y - 4, cellsContainer.width, Cell.CELL_HEIGHT * 3 + 8);
        slotsMask.endFill();
        this.addChild(slotsMask);
        setTimeout(() =>
        {
            animationContainer.mask = slotsMask;
        }, 1000);
    }

    setCells( cellModels )
    {
        let cellsContainer = this._cellsContainer; 
        cellsContainer.removeAll( true );
        
        let cellViews = this._cellViews = [];
        let dY = 0;
        cellModels.forEach((cellModel) =>
        {
            let cellView = new Cell( this.game, cellModel );
            cellView.y = dY;
            dY += cellView.height;
            cellsContainer.addChild(cellView);
            cellViews.push(cellView);
        });        
//        cellModels.forEach((cellModel) =>
//        {
//            let cellView = this._cellViews.filter((cellView) => cellView.model.cellIndex === cellModel.cellIndex);
//            if( cellView === null || cellView.length > 1 ) console.log('update slot: cell view not found');
//            cellView[0].setCell( cellModel );
//        });        
    }
    
    get model()
    {
        return this._model || null;
    }

    set model(value)
    {
        this._model = value;
    }

    get cellViews()
    {
        return this._cellViews.slice();
    }

    highlightCells(cellModels)
    {
        let cellViews = this._cellViews.filter((cellView) =>
        {
            return cellModels.some((cellModel) => cellModel.compare(cellView.model) && cellModel.highlight);
        });

        return Promise.all(
            cellViews.map((cellView) => cellView.hightlight())
        );
    }

    transformTo(cellModel, delay = 0)
    {
        return new Promise(handler.bind(this));

        function handler(res, rej)
        {
            if (!cellModel || !cellModel.type)
            {
                return rej('Invalid cell model.');
            }

            let game = this.game;
            let cellsContainer = this._cellsContainer;
            let cellViews = this._cellViews;

            cellViews.length = 0;
            cellsContainer.removeAll(true);

            let cellView = new Cell(game, cellModel);
            cellViews.push(cellView);
            cellsContainer.addChild(cellView);
            cellsContainer.y = 10;

            res(cellView.transform());
        }
    }

    spinTo(cellModels, delay = 100, spins = 2, extraSpin = false)
    {
        const additionalSpins = 5;

        if (extraSpin)
        {
            spins += additionalSpins;
        }

        return new Promise(handler.bind(this));

        function handler(res)
        {
            if (!cellModels || !cellModels.length)
            {
                console.warn('[Slot.spinTo] No cell models.');
                return res(Promise.resolve());
            }

            cellModels.sort((a, b) => a.cellIndex - b.cellIndex);

            const game = this.game;
            const bg = this._bg;
            const cellsContainer = this._cellsContainer;
            const animationContainer = this._animationContainer;
            const mix1 = this._mix1;
            const mix2 = this._mix2;
            const mixBounds = this._mixBounds;
            const cellViews = this._cellViews;

            const headCellView = cellViews.filter((view) => view.model.cellIndex === -1)[0];

            cellsContainer.position.set(
                bg.width - cellsContainer.width >> 1,
                10 + (headCellView ? -Cell.CELL_HEIGHT : 0)
            );

            cellViews.forEach((cellView) =>
            {
                cellView.stop();
            });

            let spinSound = null;

            let tweenA = game.add.tween(cellsContainer).to({ y: cellsContainer.y - 10 }, 100, 'Quart.easeOut', false, delay);
            let tweenB = game.add.tween(cellsContainer).to({ y: cellsContainer.y + 10 }, 100, 'Quart.easeOut');
            tweenA
                .chain(tweenB)
                .start().onComplete.addOnce(() =>
            {
                const reelAnimationTime = 600;

                let acc = [];
                let mixes = [mix1, mix2];
                for (let i = 0; i < spins; i++)
                {
                    ((mixes, index) =>
                    {
                        acc.push((cbk) =>
                        {
                            mixes.forEach((mix, index) =>
                            {
                                mix.y = index * mixBounds.height;
                            });

                            animationContainer.y = -mixBounds.height;
                            let tween = game.add.tween(animationContainer).to(
                                { y: 0 },
                                reelAnimationTime,
                                index === 0 ? Phaser.Easing.Linear.None : Phaser.Easing.Linear.None
                            );
                            tween.start().onComplete.addOnce(() => cbk());

                            if (extraSpin && index === spins - additionalSpins)
                            {
                                spinSound = SoundManager.sound ? SoundManager.playSound('sounds/spin', true, true) : null;

                                SoundManager.fadeOutMusic();

                                let bonusFrame = new Phaser.Sprite(this.game, -27, -29, 'bonus_frame_animation', 0);
                                this.addChild(bonusFrame);

                                let bonusFrameAnimation = bonusFrame.animations.add('animation', null, 20, true, true);
                                bonusFrameAnimation.play(20, true);
                                bonusFrameAnimation.onLoop.addOnce(() =>
                                {
                                    let tween = this.game.add.tween(bonusFrame).to({ alpha: 0 }, 1000, Phaser.Easing.Linear.None);
                                    tween.onComplete.addOnce(() =>
                                    {
                                        bonusFrameAnimation.stop();
                                        this.removeChild(bonusFrame);
                                    });
                                    tween.start();
                                });
                            }

                        });
                    })(mixes.reverse().slice(), i);
                }

                // Create finally cells
                acc.push((cbk) =>
                {
                    cellViews.length = 0;
                    cellsContainer.removeAll(true);

                    let dY = 0;
                    cellModels.forEach((cellModel) =>
                    {
                        let cellView = new Cell(game, cellModel);
                        cellView.y = dY;
                        dY += cellView.height + 1;
                        cellsContainer.addChild(cellView);
                        cellViews.push(cellView);
                    });

                    cbk();
                });

                animationContainer.visible = true;
                cellsContainer.visible = false;

                async.series(acc, () =>
                {
                    if (spinSound)
                    {
                        spinSound.stop();
                    }

                    cellsContainer.position.set(
                        bg.width - cellsContainer.width >> 1,
                        10
                    );

                    animationContainer.visible = false;
                    cellsContainer.visible = true;

                    const headCellView = cellViews.filter((view) => view.model.cellIndex === -1)[0];
                    const tailCellView = cellViews[3];
                    let shift = 0;
                    if (headCellView)
                    {
                        shift = 0;
                    }
                    else if (tailCellView)
                    {
                        shift = -Cell.CELL_HEIGHT;
                        cellViews[0].visible = false;
                    }

                    let tweenA = game.add.tween(cellsContainer).to({ y: cellsContainer.y + 20 + shift }, 50, 'Quart.easeOut');
                    let tweenB = game.add.tween(cellsContainer).to({ y: 10 + shift }, 400, 'Quart.easeOut');
                    tweenA
                        .chain(tweenB)
                        .start().onComplete.addOnce(() =>
                    {
                        SoundManager.playSound('sounds/spin-stop');
                        res(Promise.resolve());
                    });
                });
            });
        }
    }

    nudging(delay = 1000)
    {
        return new Promise((res) =>
        {
            const cellsContainer = this._cellsContainer;
            const cellViews = this._cellViews
                .slice()
                .sort((view1, view2) => view1.model.cellIndex - view2.model.cellIndex);

            const headCellView = cellViews[0].model.cellIndex < 0 ? cellViews[0] : null;
            const tailCellView = cellViews[cellViews.length - 1].model.cellIndex > 2 ? cellViews[cellViews.length - 1] : null;
            
            if (!headCellView && !tailCellView)
            {
                return res(Promise.resolve());
            }

            if (tailCellView)
            {
                cellViews[0].visible = true;
            }

            const shift = headCellView ? Cell.CELL_HEIGHT * headCellView.model.cellIndex : 0;
            const tween = game.add.tween(cellsContainer).to({ y: 10 + shift }, 600, 'Quart.easeOut', false, delay);
            tween.start().onComplete.addOnce(() =>
            {
                res(Promise.resolve());
            });
        });
    }
}